import React from 'react'
import AnalyzerDemoData from 'Pages/AnalyzersV2/@tour/DemoData'
import { demoPopoverOpen } from './signals'

// Demo shown by the Virtual Tour when no report is loaded: one row per website, one column per category
const ROWS = [
	{ name: 'eurodrive.demo', prices: [89.50, 95.20, 112.40] },
	{ name: 'rentalspot.demo', prices: [82.15, 91.80, 105.30] },
	{ name: 'pricefly.demo', prices: [85.70, 93.40, 108.90] },
	{ name: 'bookride.demo', prices: [84.20, 90.55, 103.75] },
	{ name: 'findwheels.demo', prices: [87.30, 94.10, 110.60] },
]

const COLUMNS = ['economy', 'compact', 'suv'].map(label => ({ label }))

export default function DirectSiteDemoData() {
	return <AnalyzerDemoData
		demoPopoverOpen={demoPopoverOpen}
		columns={COLUMNS}
		rows={ROWS}
		chart={{ title: 'Sites', type: 'column' }}
		withCategories
	/>
}
